import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import { AuthProvider, AuthProviderCreate, AuthProviderUpdate } from '@frontend/types';

const TOOLS_MANAGEMENT_URL = `${OPAL_URL}/tools-mgmt-service`;

export const getAuthProviders = () => {
  const key = ['auth-providers'];
  return {
    key,
    queryFn: async () => {
      const response = await http.get<AuthProvider[]>(`${TOOLS_MANAGEMENT_URL}/api/auth/providers`);
      return response.data;
    },
  };
};

export function createAuthProvider(payload: AuthProviderCreate) {
  return http.post<AuthProvider>(`${TOOLS_MANAGEMENT_URL}/api/auth/providers`, payload);
}

export function updateAuthProvider(providerId: string, payload: AuthProviderUpdate) {
  return http.put<AuthProvider>(
    `${TOOLS_MANAGEMENT_URL}/api/auth/providers/${providerId}`,
    payload
  );
}

export function deleteAuthProvider(providerId: string) {
  return http.delete(`${TOOLS_MANAGEMENT_URL}/api/auth/providers/${providerId}`);
}

export function initiateAuthTest(providerId: string, scopeBundleId: string) {
  return http.post(`${TOOLS_MANAGEMENT_URL}/api/auth/initiate`, {
    provider_id: providerId,
    scope_bundle_id: scopeBundleId,
  });
}
